module.exports = __webpack_public_path__ + "img/05.625bf171.png";